import Icon from '../Icon.vue'

Icon.register({
  'blank_solid': {
    width: 14,
    height: 21,
    paths: [
      {
        d: 'M7 .003L1 0a1 1 0 00-1 1v18a1 1 0 001 1l12 .003a1 1 0 001-1v-12H8a1 1 0 01-1-1v-6z'
      },
      {
        d: 'M9.003.003H9v5h5V5L9.003.003z'
      }
    ]
  }
})
